import { useCallback, useState } from "react"

import { usePrefersReducedMotion } from "@coval/ui"

/**
 * Pause state for content that moves on its own for longer than five seconds
 * (WCAG 2.2.2). It starts still under a reduced-motion preference, and once the
 * user toggles it, their choice overrides the preference.
 */
export function usePausableMotion() {
  const prefersReducedMotion = usePrefersReducedMotion()
  const [stillOverride, setStillOverride] = useState<boolean | null>(null)
  const isStill = stillOverride ?? prefersReducedMotion
  const toggleStill = useCallback(() => setStillOverride(!isStill), [isStill])
  return { isStill, prefersReducedMotion, toggleStill }
}
